//File thas has some of the functions that we are gonna export
var dictionaryOfTranslation = {
    'person': '人', 
    'man': '男',
    'child':'こども',
    'cat': '猫',
    'dog':'犬',
    'bird':'鳥',
    'horse':'馬',
    'car':'車',
    'truck':'トラック',
    'plane':'飛行機',
    'bicycle':'自転車',
    'chair':'イス',
    'table':'テーブル',
    'bottle':'ボトル',
    'cup':'カップ',
    'laptop':'ノートパソコン',
    'cell phone': '携帯電話',
    'television':'テレビ'
}
/*
Description: function that gonna translate the object from english to japanese
INPUT: name of the object in english 
OUTPUT: name of the object in japanese
*/
function translateFromEnglishToJapanese(word){
    if (dictionaryOfTranslation[word]!=null){
        return dictionaryOfTranslation[word]
    }
}
/*
Description: function that allows to draw into the screen: have to export
INPUT: detection object, ctx: canvas object 
OUTPUT: canvas realization, including prediction text 
*/
export const drawRectangleOfDetection = (detections,ctx)=>{
    //loop through every detection
    detections.forEach(prediction => {
        //use the results 
        const[x,y,width,height] = prediction['bbox'];
        const text = prediction['class']+' /'+translateFromEnglishToJapanese(prediction['class']);
        //draw an actual rectangle
        //gonna create random colours
        const color = '#' + Math.floor(Math.random()*5345435).toString(16);
        ctx.strokeStyle = color
        ctx.font = '18px Arial'
        ctx.fillStyle = color
        //draw rectangles and text
        ctx.beginPath()
        //method to put the right text inside 
        ctx.fillText(text,x,y)
        ctx.rect(x,y,width,height)
        ctx.stroke()
    });
}